module.exports = `:root {
  --primitiveColorNeutral270: #404040;
  --primitiveColorNeutral430: #666666;
  --primitiveColorNeutral780: #c1c1c1;
  --primitiveColorNeutral970: #f8f4f4;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorNeutral0: #000000;
  --primitiveColorGreen740: #8dc63f;
  --primitiveColorGreen790: #a5d16a;
  --primitiveColorPink560: #ff0099;
  --primitiveColorPink740: #f499c0;
  --primitiveColorPink930: #fde6f4;
}
`;